import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { ComponentProps, ReactNode } from 'react';

interface SenderActionBarProps {
	children: ReactNode;
	className?: string;
}

export function SenderActionBar({ children, className }: SenderActionBarProps) {
	return (
		<div
			className={cn(
				'flex flex-wrap gap-2 border-t border-border/60 bg-background/95 px-3 py-3 pb-[max(0.5rem,env(safe-area-inset-bottom))]',
				className,
			)}
		>
			{children}
		</div>
	);
}

export function SenderActionBarButton({
	children,
	variant = 'outline',
	...props
}: ComponentProps<typeof Button>) {
	return (
		<Button type='button' variant={variant} className='min-h-11 flex-1 text-[15px]' {...props}>
			{children}
		</Button>
	);
}
